<template>
	<div :style="securityNoticeMarginStyle">
		<div v-if="!isListingOnly" class="user-dashboard mt-1 px-5">
			<div
				class="flex flex-col items-center justify-center space-y-4 rounded bg-gray-50 p-5"
			>
				<div v-if="auUser.isLoggedIn" class="w-full">
					<div class="mb-6 flex w-full items-center justify-between">
						<div class="pl-1">
							<span class="text-xl font-semibold text-black">
								Welcome back, {{ firstName }}.
							</span>
						</div>
						<div class="pr-1">
							<IconUser
								class="h-5 w-auto fill-blue-400 text-right text-gray-500"
							/>
						</div>
					</div>
					<div class="w-full">
						<ul
							class="m-0 flex list-none flex-col gap-y-5 lg:space-x-5"
						>
							<li
								v-for="(userMenuItem, index) in userMenu"
								:key="index"
							>
								<!-- Replace Last Item Style - Logout -->
								<div
									v-if="index == userMenu.length - 1"
									class="mt-2 w-full rounded bg-gray-600 p-4 text-center"
								>
									<a
										class="font-medium text-white"
										:href="
											userMenuItem.href
												? userMenuItem.href
												: ''
										"
										@click="
											onClickMenuItem(
												userMenuItem,
												$event
											)
										"
									>
										{{ userMenuItem.label }}
									</a>
								</div>
								<div v-else>
									<a
										class="px-1 font-medium text-gray-600"
										:href="
											userMenuItem.href
												? userMenuItem.href
												: ''
										"
										@click="
											onClickMenuItem(
												userMenuItem,
												$event
											)
										"
									>
										{{ userMenuItem.label }}
									</a>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div
					v-if="!auUser.isLoggedIn"
					class="flex w-full flex-col space-y-4"
				>
					<CarbarLink
						:href="whitelabel.styles?.signUpUrl"
						:underline="false"
						@click="toggleMobileMenu()"
					>
						<CarbarButton
							:is-full-width="true"
							:background-color="whitelabel.styles?.button?.bg"
							:rounded="whitelabel.styles?.button?.borderRadius"
							:class="whitelabel.styles?.fontWeight"
						>
							Sign up
						</CarbarButton>
					</CarbarLink>
					<CarbarLink
						:href="whitelabel.styles?.signInUrl"
						:underline="false"
						@click="toggleMobileMenu()"
					>
						<CarbarButton
							:is-outline="true"
							:is-full-width="true"
							:class="whitelabel.styles?.fontWeight"
							:rounded="whitelabel.styles?.button?.borderRadius"
							:outline-color="[
								whitelabel.styles?.button?.outline,
								'group border duration-300 ease-out',
							]"
							:text-color="[
								whitelabel.styles?.button?.outlineText,
								'group duration-300 ease-out',
							]"
						>
							Sign in
						</CarbarButton>
					</CarbarLink>
				</div>
			</div>
		</div>
		<div class="container mt-5">
			<ul class="mt-0 flex list-none flex-col space-y-8 p-5">
				<li
					v-for="menuItem in menu"
					:key="menuItem.label"
					class="flex"
					:class="menuItem.class"
				>
					<CarbarLink
						text-color="text-gray-700"
						font-size="text-xl"
						font-weight="font-medium"
						:hover-color="whitelabel.styles?.hoverColor"
						:underline="false"
						:href="menuItem.link"
						:target="menuItem.target"
					>
						{{ menuItem.label }}
					</CarbarLink>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
import IconUser from '@/assets/svg/common/ico-user.svg'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import { useCarbarAuAuthStore } from '@/stores/carbar-au-auth'
import { headerModule } from '@/utils/Header.js'

const auUser = useCarbarAuAuthStore()
const isListingOnly = useIsListingOnly()
const { securityNoticeMarginStyle } = useSecurityNotice()

const firstName = ref(auUser.firstName)

const { toggleMobileMenu } = headerModule()

const props = defineProps({
	menu: {
		type: Object,
	},
})

const { whitelabel } = useWhitelabelsStyles()

const emits = defineEmits(['login', 'join', 'clickMenuItem'])

const userMenu = ref([
	{
		label: 'Dashboard',
		href: '/dashboard',
	},
	{
		label: 'Account',
		href: '/dashboard/account',
	},
	{
		label: 'Help & support',
		link: `${whitelabel.value.links.faqUrl}`,
	},
	{
		label: 'Logout',
		onclick: () => {
			signOut()
		},
	},
])
</script>
